var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGd(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    height: 480,
    width: 640,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "red",
    d: "M0 0h640v480H0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#009a00",
    d: "M145.996 83.454h360.91v314.41h-360.91z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.996 397.865h360.91l-180.46-157.19-180.46 157.19z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M145.996 83.528l180.46 157.19 180.45-157.19h-360.91z",
    fill: "#ffca00"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M177.71 61.366L161.263 49.64l-16.466 11.698 6.073-19.262-16.207-12.044 20.192-.177 6.446-19.14 6.41 19.152 20.192.212-16.236 12.014m170.93 19.763L326.15 50.128l-16.466 11.7 6.073-19.263-16.207-12.043 20.192-.178 6.446-19.14 6.408 19.152 20.193.213-16.237 12.013M507.59 61.59l-16.447-11.727-16.466 11.7L480.75 42.3l-16.207-12.044 20.192-.177 6.446-19.142 6.41 19.153 20.192.213-16.236 12.015M177.71 468.793l-16.447-11.728-16.466 11.7 6.073-19.263-16.207-12.043 20.192-.18 6.446-19.14 6.41 19.153 20.192.213-16.236 12.014m170.93 19.764l-16.447-11.728-16.466 11.7 6.073-19.263-16.207-12.043 20.192-.18 6.446-19.14 6.408 19.153 20.193.213-16.237 12.014m171.038 19.014l-16.447-11.728-16.466 11.7 6.073-19.263-16.207-12.043 20.192-.18 6.446-19.14 6.41 19.153 20.192.213-16.236 12.014"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M369.722 243.097c0 24.172-19.594 43.765-43.764 43.765s-43.765-19.594-43.765-43.765c0-24.17 19.595-43.764 43.765-43.764s43.764 19.594 43.764 43.764z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#ffce00",
    d: "M345.755 270.04l-19.536-13.93-19.56 13.895 7.214-22.88-19.25-14.305 23.984-.21 7.657-22.738 7.612 22.75 23.985.253-19.286 14.272"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M169.972 273.464s2.22-18.394.952-30.762c-1.27-12.368-32.983-15.857-32.983-15.857l-.316 28.86s25.372 20.613 32.348 17.76z",
    fill: "red"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M123.67 200.525s3.056 16.207-1.27 48.522c-2.31 17.546 16.81 29.494 40.278 34.885-4.757-8.245-17.442-21.565-14.27-45.985 17.124 2.22 33.298 35.52 33.298 35.52s12.813-47.217-13.003-54.547c-25.09-7.05-45.033-18.077-45.033-18.394z",
    fill: "#ffce00"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGd);
export default __webpack_public_path__ + "static/media/gd.afbcfdf0fec09713ebba0166752cae11.svg";
export { ForwardRef as ReactComponent };